import { render, staticRenderFns } from "./relations.vue?vue&type=template&id=4218353e&"
import script from "./relations.vue?vue&type=script&lang=js&"
export * from "./relations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports